import { FUND } from "./types"

const handleFetchCards = (data) => ({
    type: FUND.FETCH_CARDS,
    payload: data,
})

const fetchCardSuccess = (data) => ({
    type: FUND.FETCH_CARD_SUCCESS,
    payload: data
})

const fundBank = (data) => ({
    type: FUND.FUND_BANK,
    payload: data,
});

const fundBankSuccess = (data) => ({
    type: FUND.FUND_BANK_SUCCESS,
    payload: data,
});

const fundBankFail = (data) => ({
    type: FUND.FUND_BANK_FAIL,
    payload: data,
});

const fundCard = (data, history) => ({
    type: FUND.FUND_CARD,
    payload: data,
    history
});

const fundCardSuccess = (data) => ({
    type: FUND.FUND_CARD_SUCCESS,
    payload: data,
})

const fundCardFail = (data) => ({
    type: FUND.FUND_CARD_FAIL,
    payload: data,
});

const fundUssd = (data) => ({
    type: FUND.FUND_USSD,
    payload: data,
});

const fundUssdSuccess = (data) => ({
    type: FUND.FUND_USSD_SUCCESS,
    payload: data,
});

const fundUssdFail = (data) => ({
    type: FUND.FUND_USSD_FAIL,
    payload: data,
})

const createCard = data => ({
    type: FUND.CREATE_CARD,
    payload: data
})

const fetchWalletHistory = data => ({
    type: FUND.WALLET_HISTORY,
    payload: data
})


const fetchWalletHistorySuccess = data => ({
    type: FUND.WALLET_HISTORY_SUCCESS,
    payload: data
})

export {
    fundBank,
    fundBankSuccess,
    fundBankFail,
    fundCard,
    fundCardSuccess,
    fundCardFail,
    fundUssd,
    fundUssdSuccess,
    fundUssdFail,
    handleFetchCards,
    fetchCardSuccess,
    createCard,
    fetchWalletHistory,
    fetchWalletHistorySuccess
}